import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

interface HeaderProps {
  callId?: string;
  domainId?: string;
  sessionId?: string;
  userEmail: string;
  onLogout: () => void;
  onVAConfigClick?: () => void;
  onESSConfigClick?: () => void;
  onFlowAnalyzerClick?: () => void;
  onTranscriptionAnalyzerClick?: () => void;
  onTagAnalyzerClick?: () => void;
  onVoiceStreamAnalyzerClick?: () => void;
  onSLIClick?: () => void;
  sector?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  callId, 
  domainId, 
  sessionId, 
  userEmail, 
  onLogout,
  onVAConfigClick,
  onESSConfigClick,
  onFlowAnalyzerClick,
  onTranscriptionAnalyzerClick,
  onTagAnalyzerClick,
  onVoiceStreamAnalyzerClick,
  onSLIClick,
  sector
}) => {

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    if (callId && domainId && sector) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="header">
      <div className="header-info">
        {callId && (
          <div className="header-item">
            Call ID: <span>{callId}</span>
          </div>
        )}
        {domainId && (
          <div className="header-item">
            Domain: <span>{domainId}</span>
          </div>
        )}
        {sessionId && (
          <div className="header-item">
            Session: <span>{sessionId.substring(0, 8)}...</span>
          </div>
        )}
      </div>
      
      <div className="user-info">
        {onVAConfigClick && (
          <button className="va-config-btn" onClick={onVAConfigClick}>
            🤖 Agent Assistants
          </button>
        )}
        {onESSConfigClick && (
          <button className="va-config-btn" onClick={onESSConfigClick}>
            🤖 ESS Config
          </button>
        )}
        {(onFlowAnalyzerClick || onTranscriptionAnalyzerClick || onTagAnalyzerClick || onVoiceStreamAnalyzerClick) && (
          <button onClick={handleMenuClick} className="kebab-menu-btn">
            <MoreVertIcon />
          </button>
        )}
        <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
          {onFlowAnalyzerClick && callId && domainId && sector && (
            <MenuItem onClick={() => { onFlowAnalyzerClick(); handleMenuClose(); }}>
              📊 Flow Analyzer
            </MenuItem>
          )}
          {onTranscriptionAnalyzerClick && callId && domainId && (
            <MenuItem onClick={() => { onTranscriptionAnalyzerClick(); handleMenuClose(); }}>
              📊 Transcription Analyzer
            </MenuItem>
          )}
          {onTagAnalyzerClick && callId && domainId && (
            <MenuItem onClick={() => { onTagAnalyzerClick(); handleMenuClose(); }}>
              📊 Tag Analyzer
            </MenuItem>
          )}
          {onVoiceStreamAnalyzerClick && callId && domainId && (
            <MenuItem onClick={() => { onVoiceStreamAnalyzerClick(); handleMenuClose(); }}>
              📊 VoiceStream Analyzer
            </MenuItem>
          )}
          {onSLIClick && callId && domainId && (
            <MenuItem onClick={() => { onSLIClick(); handleMenuClose(); }}>
              📊 SLI Entries
            </MenuItem>
          )}
        </Menu>
        <span>{userEmail}</span>
        <button className="logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Header;
